import React from 'react'
import './index.scss'

//other libraries
import { inject, observer } from 'mobx-react'

//material-ui
import {
  Paper,
  Grid,
  List,
  ListItem,
  ListSubheader,
  Table,
  TableHead,
  TableBody, TableCell, TableRow, TextField, CircularProgress,
} from '@material-ui/core'

//custom components
import moment from 'moment'
import CustomButton from '../../../../components/basic/CustomButton'
import { toJS } from 'mobx'
import { api } from '../../../../functions/api'
import MenuItem from '@material-ui/core/MenuItem'

@inject('internal')
@inject('translate')
@observer
export default class ProductPrices extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      loading: false,
    }
  }
  
  initiateExport = () => {
    const { dataForSimpeTable: data } = this.props.internal
    api({
      method: 'get',
      url: `issue-cards/${data.id}/export`,
      authorization: this.props.internal.user.access_token,
    }).then(response => {
      if (response.success) {
        window.open(response.data.data.url, '_blank')
      }
    })
  }
  
  initiateHistoryExport = () => {
    const { dataForSimpeTable: data } = this.props.internal
    api({
      method: 'get',
      url: `issue-cards/${data.id}/export-history`,
      authorization: this.props.internal.user.access_token,
    }).then(response => {
      if (response.success) {
        window.open(response.data.data.url, '_blank')
      }
    })
  }
  
  handleChangeStatus = (issue_card_history_status_id) => {
    const { dataForSimpeTable: data } = this.props.internal
    this.setState({loading: true})
    api({
      method: 'patch',
      url: `issue-cards/${data.id}`,
      authorization: this.props.internal.user.access_token,
      params: {
        issue_card_history_status_id,
      },
    }).then(response => {
      this.setState({loading: false})
      if (response.success) {
        this.props.internal.setDataForSimpeTable(response.data.data)
      }
      this.props.internal.setSnackbar(response.data.message, true, !response.success)
    })
  }
  
  render() {
    const { dataForSimpeTable: data } = this.props.internal
    const permissions = toJS(this.props.internal.user.data.permissions)
    
    return (
      <div className={'just-text-issue-cards'}>
        <Grid container spacing={16}>
          <Grid item xs={12} md={5}>
            <Paper className={'container-issue-cards'}>
              <List
                subheader={
                  <ListSubheader disableSticky>
                    <Grid container justify={'space-between'}>
                      <Grid item>
                        {this.props.translate.i18n.MODULES.ISSUE_CARDS.CLIENT_DATA}
                      </Grid>
                      {permissions.issue_cards.export ? (
                        <Grid item>
                          <CustomButton
                            onClick={this.initiateExport}
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.MODULES.ISSUE_CARDS.GENERATE_PDF}
                            justText
                          />
                        </Grid>
                      ) : null}
                    </Grid>
                  </ListSubheader>}
                dense>
                <ListItem>
                  {this.state.loading ? <CircularProgress className={'circular-progress'}/> : (
                    <TextField
                      id={'status'}
                      select
                      label={this.props.translate.i18n.MODULES.ISSUE_CARDS.LAST_ENTRY_STATUS}
                      fullWidth
                      value={data.last_entry.issue_card_history_status.id}
                      onChange={e => this.handleChangeStatus(e.target.value)}
                    >
                      <MenuItem value={1}>{this.props.translate.i18n.MODULES.ISSUE_CARDS.STATUS.NEW}</MenuItem>
                      <MenuItem value={2}>{this.props.translate.i18n.MODULES.ISSUE_CARDS.STATUS.FROM_STORAGE}</MenuItem>
                      <MenuItem value={3}>{this.props.translate.i18n.MODULES.ISSUE_CARDS.STATUS.READY_TO_EXPEDITE}</MenuItem>
                      <MenuItem value={4}>{this.props.translate.i18n.MODULES.ISSUE_CARDS.STATUS.EXPEDITED}</MenuItem>
                      <MenuItem value={5}>{this.props.translate.i18n.MODULES.ISSUE_CARDS.STATUS.DELIVERED}</MenuItem>
                    </TextField>
                  )}
                </ListItem>
                <ListItem>
                  <TextField
                    id={'client_id_no'}
                    label={this.props.translate.i18n.MODULES.ISSUE_CARDS.CLIENT_ID_NO}
                    fullWidth
                    disabled
                    value={data.client_id_no || 'N/A'}
                  />
                </ListItem>
                <ListItem>
                  <TextField
                    id={'client_name'}
                    label={this.props.translate.i18n.MODULES.ISSUE_CARDS.CLIENT_NAME}
                    fullWidth
                    disabled
                    value={data.client_name || 'N/A'}
                  />
                </ListItem>
                <ListItem>
                  <TextField
                    id={'issue_date_at'}
                    label={this.props.translate.i18n.MODULES.ISSUE_CARDS.ISSUE_DATE_AT}
                    fullWidth
                    disabled
                    value={data.issue_date_at ? moment(data.issue_date_at).format('DD.MM.YYYY') : 'N/A'}
                  />
                </ListItem>
                <ListItem>
                  <TextField
                    id={'order_number'}
                    label={this.props.translate.i18n.MODULES.ISSUE_CARDS.ORDER_NUMBER}
                    fullWidth
                    disabled
                    value={data.order_number || 'N/A'}
                  />
                </ListItem>
                <ListItem>
                  <TextField
                    id={'delivery_note'}
                    label={this.props.translate.i18n.MODULES.ISSUE_CARDS.DELIVERY_NOTE}
                    fullWidth
                    disabled
                    value={data.delivery_note || 'N/A'}
                  />
                </ListItem>
              </List>
            </Paper>
          </Grid>
          <Grid item sm={12} md={7}>
            <Paper className={'container-issue-cards2'}>
              <Grid container>
                <Grid item sm={12}>
                  <List
                    subheader={
                      <ListSubheader disableSticky>
                        <Grid container justify={'space-between'}>
                          <Grid item>
                            {this.props.translate.i18n.MODULES.ISSUE_CARDS.HISTORY}
                          </Grid>
                          {permissions.issue_cards.export ? (
                            <Grid item>
                              <CustomButton
                                onClick={this.initiateHistoryExport}
                                mystyle={'btn-white-bg'}
                                title={this.props.translate.i18n.GLOBAL.MENU.EXPORT}
                                justText
                              />
                            </Grid>
                          ) : null}
                        </Grid>
                      </ListSubheader>}
                    dense>
                    <ListItem>
                      <div className={'issue-card-detail-history'}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>
                                {this.props.translate.i18n.MODULES.ISSUE_CARDS.DATE}
                              </TableCell>
                              <TableCell>
                                {this.props.translate.i18n.MODULES.ISSUE_CARDS.USER}
                              </TableCell>
                              <TableCell>
                                {this.props.translate.i18n.MODULES.ISSUE_CARDS.LAST_ENTRY_STATUS}
                              </TableCell>
                              <TableCell>
                                {this.props.translate.i18n.MODULES.ISSUE_CARDS.PRODUCT}
                              </TableCell>
                              <TableCell>
                                {this.props.translate.i18n.MODULES.PRODUCTS.SERIAL_NUMBER}
                              </TableCell>
                              <TableCell>
                                {this.props.translate.i18n.MODULES.ISSUE_CARDS.PIECES}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {data.history.map(entry => (
                              <TableRow key={entry.id}>
                                <TableCell>
                                  {moment(entry.created_at).format('DD.MM.YYYY HH:mm')}
                                </TableCell>
                                <TableCell>
                                  {entry.user.username}
                                </TableCell>
                                <TableCell>
                                  {this.props.translate.i18n.MODULES.ISSUE_CARDS.STATUS[entry.issue_card_history_status.name.toUpperCase()]}
                                </TableCell>
                                <TableCell>
                                  {entry.product ? entry.product.name : 'N/A'}
                                </TableCell>
                                <TableCell>
                                  {entry.serial_number || 'N/A'}
                                </TableCell>
                                <TableCell>
                                  {entry.pieces || 'N/A'}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </div>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/IssueCards/detail/basic/index.js